import { Navigate } from "react-router-dom";

export default function Access() {
 if (localStorage.getItem("token") !== null)
  return <Navigate to="/admin/dashboard" replace />;
 else
  return <Navigate to="/auth/login" replace />;
}
